//20250328,1740
// src/App.js
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import i18n from './i18n';
import Seo from './Seo';
import HomePage from './pages/HomePage';
import FaqPage from './pages/FaqPage';
import FaqSectionPage from './pages/FaqSectionPage';
import BlogDetailPage from './pages/BlogDetailPage';
import FaqSearchResultPage from './pages/FaqSearchResultPage';
import AboutPage from './pages/AboutPage';
import BlogPage from './pages/BlogPage';
import PartnersPage from './pages/PartnersPage';
import PartnersDetailPage from './pages/PartnersDetailPage';
import ListMyBusinessPage from './pages/ListMyBusinessPage';
import JoinUsPage from './pages/JoinUsPage';
import PartnerLoginPage from './pages/PartnerLoginPage';
import PartnerRegisterPage from './pages/PartnerRegisterPage';
import DiscoverMorePage from './pages/DiscoverMorePage';
import OurStoryPage from './pages/OurStoryPage';
import TermsAndConditionsPage from './pages/TermsAndConditionsPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import PlansPage from './pages/PlansPage';
import DownloadPage from './pages/DownloadPage';
import ContactUsPage from './pages/ContactUsPage';
import NotFoundPage from './pages/NotFoundPage';

function AppContent() {
    const location = useLocation();

    useEffect(() => {
        const lang = location.pathname.startsWith('/hk') ? 'zh-HK' : 'en';
        i18n.changeLanguage(lang);
    }, [location]);

    const createRoutes = (prefix = '') => (
        <>
            <Route path={`${prefix}/`} element={<HomePage />} />
            <Route path={`${prefix}/faqs`} element={<FaqPage />} />
            <Route path={`${prefix}/faqs/searchResult`} element={<FaqSearchResultPage />} />
            <Route path={`${prefix}/faqs/:sectionName`} element={<FaqSectionPage />} />
            <Route path={`${prefix}/blogs`} element={<BlogPage />} />
            <Route path={`${prefix}/blogs/:searchName`} element={<BlogDetailPage />} />
            <Route path={`${prefix}/about`} element={<AboutPage />} />
            <Route path={`${prefix}/partners`} element={<PartnersPage />} />
            <Route path={`${prefix}/partners/:partnerName`} element={<PartnersDetailPage />} />
            <Route path={`${prefix}/list-my-business`} element={<ListMyBusinessPage />} />
            <Route path={`${prefix}/ourstory`} element={<OurStoryPage />} />
            <Route path={`${prefix}/terms-and-conditions`} element={<TermsAndConditionsPage />} />
            <Route path={`${prefix}/privacy`} element={<PrivacyPolicyPage />} />
            <Route path={`${prefix}/plans`} element={<PlansPage />} />
            <Route path={`${prefix}/join-us`} element={<JoinUsPage />} />
            <Route path={`${prefix}/partner-login`} element={<PartnerLoginPage />} />
            <Route path={`${prefix}/partner-register`} element={<PartnerRegisterPage />} />
            <Route path={`${prefix}/discover-more`} element={<DiscoverMorePage />} />
            <Route path={`${prefix}/download`} element={<DownloadPage />} />
            <Route path={`${prefix}/contact`} element={<ContactUsPage />} />
            <Route path={`${prefix}/*`} element={<NotFoundPage />} />
        </>
    );

    return (
        <>
            <Seo />
            <Routes>
            {createRoutes()}
            {createRoutes('/hk')}
            </Routes>
        </>
    );
}

function App() {
    return (
        <Router>
            <AppContent />
        </Router>
    );
}

export default App;